import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {browserHistory}  from 'react-router'
import {
    PanelBody, MediaBox, MediaBoxTitle, MediaBoxDescription, PanelFooter, Panel,
    Dialog, ActionSheet, LoadMore
} from 'react-weui'
import { fixBackContentEmpty } from '../../utils'
import { WKVisible } from '../../components'
import yxImg from '../../images/detail_title_yx.png'
import { SearchEmpty, ListEmpty } from '../../components/liveroomLecturer'
import * as liveroomSetAct from '../../actions/liveroomSettingLecture'


class ChannelList extends React.Component {
    constructor(props) {
        super(props)
        this.searchMenu = [{
            label: <span style={{color:'#e64340'}}>删除</span>,
            onClick: () => this.onClickDelChannel()
        }]
        this.menu = [{
            label: '上移',
            onClick: () => this.props.postMoveChannel(this.props.currentChannel.id, this.props.liveroomId, 'up', this.props.currentChannelIndex)
        }, {
            label: '下移',
            onClick: () => this.props.postMoveChannel(this.props.currentChannel.id, this.props.liveroomId, 'down', this.props.currentChannelIndex)
        }, {
            label: '数据分析',
            onClick: () => {
                this.props.setIsChaMenuShow(false)
                setTimeout(() => {
                    location.assign(`/channel/${this.props.currentChannel.id}/analysis`)
                }, 300)
            }
        },{
            label: <span style={{color:'#e64340'}}>删除</span>,
            onClick: () => this.onClickDelChannel()
        }]
    }
    componentDidMount() {
        this.fetchData()
        fixBackContentEmpty()
    }
    fetchData () {
        this.props.fetchChannels(this.props.liveroomId, {
            keyword: this.props.channelKeyword
        })
    }
    onClickOpera(item, i) {
        this.props.setCurrentChannelIndex(i)
        this.props.setCurrentChannel(item)
        this.props.setIsChaMenuShow(true)
    }
    renderMoney(item) {
        if (item.lecture_type === 'password_lecture') return '';
        return ''
    }
    onClickDelChannel() {
        this.props.postCheckDelChannel(this.props.currentChannel.id)
        this.props.setIsChaMenuShow(false)
    }
    onClickDelChannelOk() {
        this.props.delChannel(this.props.currentChannel.id, this.props.liveroomId, this.props.channelKeyword)
        this.props.setIsShowDelChannel(false)
        this.props.setIsChaMenuShow(false)
    }
    getOperaMenu () {
        if (this.props.currentChannelIndex === 0) {
            return this.menu.filter((item, i) => i !== 0)
        }
        if (this.props.currentChannelIndex === this.props.channels.length - 1) {
            return this.menu.filter((item, i) => i !== 1)
        }
        return this.menu
    }
    render() {
        const list = this.props.channels
        if (list === null) {
            return <LoadMore loading>正在加载</LoadMore>
        }
        return (
            <div>
                {
                    list.map((item, i) => {
                        return (
                            <Panel key={item.id}>
                                <PanelBody onClick={e => this.props.pushPath('channel', item.id)}>
                                    <MediaBox type="text">
                                        <MediaBoxTitle>
                                            <WKVisible tag='span' create={item.is_preffered}>
                                                <img className='yx-img' src={yxImg} alt="优选" />
                                            </WKVisible>
                                            <span className="title-text">{item.is_relay ? '【转】' : ''}{item.name}</span>
                                        </MediaBoxTitle>
                                        <MediaBoxDescription>
                                            <span className='weui-flex' style={{ width: '100%'}}>
                                                <span className='weui-flex__item'>
                                                    <span className="placeholder">已更新{item.lecture_count}期</span>
                                                    <span className="people-count">{item.popular}人气</span>
                                                </span>
                                                <span className='text-right weui-flex__item'>
                                                    <span className="red">{this.renderMoney(item)}</span>
                                                </span>
                                            </span>
                                        </MediaBoxDescription>
                                    </MediaBox>
                                </PanelBody>
                                <PanelFooter>
                                    <div className="opera-btn" onClick={e => this.onClickOpera(item, i)}>操作</div>
                                </PanelFooter>
                            </Panel>
                        )
                    })
                }

                <WKVisible create={this.props.isChannelsEmpty}>
                    <ListEmpty type='channel' />
                </WKVisible>

                <WKVisible show={this.props.isSearchEmpty}>
                    <SearchEmpty />
                </WKVisible>

                <Dialog type="ios" title='' show={this.props.isShowDelChannelConfirm} buttons={[{
                    label: '删除',
                    type: 'default',
                    onClick: () => this.onClickDelChannelOk(),
                }, {
                    label: '暂不删除',
                    onClick: () => this.props.setIsShowDelChannel(false),
                }]}>
                    是否确认删除专栏，专栏若被删除，专栏内所有课程将会同步删除
                </Dialog>

                <ActionSheet
                    menus={this.props.channelKeyword === '' ? this.getOperaMenu() : this.searchMenu}
                    actions={[{
                        label: '取消',
                        onClick: () => {
                            this.props.setIsLecMenuShow(false)
                            this.props.setIsChaMenuShow(false)
                        }
                    }]}
                    show={this.props.channelMenuShow}
                    type="ios"
                    onRequestClose={e => this.props.setIsChaMenuShow(false)}
                />
            </div>
        )
    }
}

export default connect(state => ({
    channels: state.liveroomSettingLecture.channels,
    currentChannel: state.liveroomSettingLecture.currentChannel,
    isShowDelChannelConfirm: state.liveroomSettingLecture.isShowDelChannelConfirm,
    channelMenuShow: state.liveroomSettingLecture.channelMenuShow,
    channelKeyword: state.liveroomSettingLecture.channelKeyword,
    isSearchEmpty: state.liveroomSettingLecture.isSearchEmpty,
    isChannelsEmpty: state.liveroomSettingLecture.isChannelsEmpty,
    currentChannelIndex: state.liveroomSettingLecture.currentChannelIndex,
}), dispatch => bindActionCreators({ ...liveroomSetAct }, dispatch))(ChannelList)



// WEBPACK FOOTER //
// ./src/components/liveroomLecturer/ChannelList.js